import { useState } from "react";
import { useAuthStore } from "../../store/auth.js";

const PERSONAS = [
  { label: "Employee", email: "d.pugachevich@mantledc.ai", name: "Dima P." },
  { label: "Applicant", email: "jane.doe@gmail.com", name: "Jane Doe" },
] as const;

export function DevToolbar() {
  const user = useAuthStore((s) => s.user);
  const fetchUser = useAuthStore((s) => s.fetchUser);
  const [switching, setSwitching] = useState(false);

  if (!import.meta.env.DEV) return null;

  const currentPersona = user?.role === "employee" ? "Employee" : "Applicant";

  const switchTo = async (persona: (typeof PERSONAS)[number]) => {
    setSwitching(true);
    try {
      const params = new URLSearchParams({
        email: persona.email,
        name: persona.name,
      });
      await fetch(`/api/v1/dev/switch-user?${params}`, { method: "POST" });
      await fetchUser();
      window.location.href = "/";
    } finally {
      setSwitching(false);
    }
  };

  return (
    <div className="fixed bottom-3 right-3 z-[9999] flex items-center gap-1.5 rounded-full border border-yellow-300 bg-yellow-50 px-3 py-1.5 text-xs shadow-lg">
      <span className="font-medium text-yellow-800">DEV</span>
      <span className="text-yellow-600">·</span>
      <span className="text-yellow-700">{currentPersona}</span>
      <span className="text-yellow-600">·</span>
      {PERSONAS.filter((p) => p.label !== currentPersona).map((p) => (
        <button
          key={p.label}
          onClick={() => switchTo(p)}
          disabled={switching}
          className="rounded-full bg-yellow-200 px-2 py-0.5 font-medium text-yellow-800 hover:bg-yellow-300 disabled:opacity-50 transition-colors"
        >
          → {p.label}
        </button>
      ))}
    </div>
  );
}
